module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/zh-hant/3-7bb45513564ddc89bd015d9d06eae171.jpg";